import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from "react-router-dom";

function Users() {
    const { t } = useTranslation();

    document.title = `Yoda - ${t('app.users')}`;

    return (
        <div className="Users">
            <Outlet />
        </div>
    );
}

export default Users;
